export enum HttpStatusCode {
  FORBIDDEN = 403,
  NOT_FOUND = 404,
}
